import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const SUPPORTED = ["en", "es", "fr", "de", "ru", "zh", "it", "pt"];

function detectLang() {
  try {
    const stored = localStorage.getItem("cr_lang");
    if (stored && SUPPORTED.includes(stored)) return stored;
    const nav = (navigator.languages || [navigator.language || "en"]).map((l) =>
      l.toLowerCase()
    );
    for (const l of nav) {
      const base = l.split("-")[0];
      if (base === "zh") return "zh";
      if (SUPPORTED.includes(base)) return base;
    }
  } catch (e) {}
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    setLangState(detectLang());
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (!SUPPORTED.includes(l)) return;
    try {
      localStorage.setItem("cr_lang", l);
    } catch (e) {}
    setLangState(l);
  };

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
